export default function isAgeIn (age, scope) {
  const testers = []
  if (scope.beginAge) {
    if (scope.beginAge.unit === 'd') {
      if (age.y === 0 && age.d < scope.beginAge.value) {
        testers.push(false)
      } else {
        testers.push(true)
      }
    } else {
      if (age.y >= scope.beginAge.value) {
        testers.push(true)
      } else {
        testers.push(false)
      }
    }
  }

  if (scope.endAge) {
    if (scope.endAge.unit === 'd') {
      if (age.y === 0 && age.d <= scope.endAge.value) {
        testers.push(true)
      } else {
        testers.push(false)
      }
    } else {
      if (age.y <= scope.endAge.value) {
        testers.push(true)
      } else {
        testers.push(false)
      }
    }
  }

  if (testers.length === 0 || testers.indexOf(false) === -1) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/isAgeIn.js